import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from '../../_service/leads.service';
declare var $: any;

@Component({
  selector: 'app-add-update-ipd-resources',
  templateUrl: './add-update-ipd-resources.component.html',
  styleUrls: ['./add-update-ipd-resources.component.css']
})
export class AddUpdateIpdResourcesComponent implements OnInit {
  IpdResourcesForm: FormGroup;submitted = false;loading:boolean=false;RecordId: any = '';pageType='';PageTitle:string;pageLink:string;treatments=[];treatments_copy=[];
    
  constructor(private leadapi:LeadsService,private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,private activatedRoute: ActivatedRoute,public miscapi:MiscService)
  {   

      this.IpdResourcesForm = this.formBuilder.group({ 
          'name' : [null, Validators.required],
          'price' : [null, Validators.required],
          'status' : [null, Validators.required]
      });


     
      this.activatedRoute.params.subscribe(params => {
        if (params['page_type']) {
            this.RecordId = params['record_id'];
            this.pageType = params['page_type'];
            if(this.RecordId){
              this.patchIpdRecourceData();
            }
            if(this.pageType=='1'){
              this.PageTitle='Consumables';
              this.pageLink='consumables-list/1';
            }else if(this.pageType=='2'){
              this.PageTitle='Lapset Vendor';
              this.pageLink='lapset-vendor-list/2';
            }else if(this.pageType=='3'){
              this.PageTitle='Anaesthetist';
              this.pageLink='anaesthetist-list/3';
            }else if(this.pageType=='4'){
              this.PageTitle='Rental';
              this.pageLink='rental-list/4';
            }    
        }
      });
  }

  setSearchValue(type){
    if(type=='treatment'){
        $("#treatmentSearch").val('');
        $("#treatmentSearch").focus();
        this.treatments= this.treatments_copy;
    }
}

searchOnSelect(searchtText: string, type){
    if(type == 'treatment'){
        this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    }
}


  get f() { return this.IpdResourcesForm.controls; }

  async patchIpdRecourceData()
  {
      this.miscapi.getIpdResourceData(this.RecordId).subscribe((response:any) => 
      {
         if(response.status)
         {
             this.IpdResourcesForm.patchValue({
               'name':response.data.name,
               'price':response.data.price,
               'status':response.data.status,   
              })
         }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  ngOnInit(): void 
  {
    this.getTreatment();
  }

  async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

  async createIpdResource(){
      this.submitted = true;
      this.loading = true;
      // stop here if form is invalid
      if (this.IpdResourcesForm.invalid) {
          this.loading = false;
          return;
      }
      this.IpdResourcesForm.value.type= parseInt(this.pageType); 
      //For Update//
      if(this.RecordId){
        this.IpdResourcesForm.value.id= parseInt(this.RecordId); 

      await this.miscapi.updateIpdResource(this.IpdResourcesForm.value)
      .subscribe((data:any) => {
          this.submitted = false;
          this.loading = false;
          if(data.status)
          {
              this.sharedapi.presentToast(this.PageTitle+' Update Successfully');
              this.router.navigateByUrl('/'+this.pageLink);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error => 
          {
              this.sharedapi.checkError(error);
          });  
      }else{ 
          //For Add//
        await this.miscapi.addIpdResource(this.IpdResourcesForm.value)
       .subscribe((data:any) => {
          this.submitted = false;
          this.loading = false;
          if(data.status)
          {
              this.sharedapi.presentToast(this.PageTitle+' Added Successfully');
              this.router.navigateByUrl('/'+this.pageLink);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error => 
          {
              this.sharedapi.checkError(error);
          }); 
      }
  }


}